/**
 * AppShell — the global frame for every authenticated page.
 *
 * Desktop (>= sm) : permanent Sidebar on the left, main shifted by 88px.
 * Mobile (< sm)   : BottomTabBar pinned to the bottom, main gets bottom
 *                   padding so the last row is not hidden under the bar.
 */
import type { ReactNode } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { BottomTabBar } from '@/components/BottomTabBar';
import { WorkspaceBanner } from '@/components/WorkspaceBanner';
import { GuidedTour } from '@/components/GuidedTour';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <>
      <Sidebar />
      <main className="min-h-screen pb-[calc(92px+env(safe-area-inset-bottom))] sm:pb-0 sm:pl-[88px]">
        <WorkspaceBanner />
        {children}
      </main>
      <BottomTabBar />
      <GuidedTour />
    </>
  );
}
